/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseOralExamConfigData } from './genericApiResponseOralExamConfigData';
import type { GenericApiResponseOralExamConfigMessage } from './genericApiResponseOralExamConfigMessage';
import type { GenericApiResponseOralExamConfigPagination } from './genericApiResponseOralExamConfigPagination';
import type { GenericApiResponseOralExamConfigError } from './genericApiResponseOralExamConfigError';

export interface GenericApiResponseOralExamConfig {
  data?: GenericApiResponseOralExamConfigData;
  message?: GenericApiResponseOralExamConfigMessage;
  pagination?: GenericApiResponseOralExamConfigPagination;
  error?: GenericApiResponseOralExamConfigError;
  statusCode?: number;
}
